import axios from "axios";
import { supabase } from "./supabaseClient";

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Edge Functions live at https://<project-ref>.supabase.co/functions/v1/<fn-name>
export const FUNCTIONS_BASE = `${SUPABASE_URL}/functions/v1`;

const api = axios.create({ baseURL: FUNCTIONS_BASE });

// Every Edge Function call needs the anon apikey header (Supabase's gateway
// requires it even when the function itself also checks the user's JWT),
// plus the user's own access token so the function can identify who's calling.
api.interceptors.request.use(async (cfg) => {
  cfg.headers.apikey = SUPABASE_ANON_KEY;
  const { data } = await supabase.auth.getSession();
  if (data?.session?.access_token) {
    cfg.headers.Authorization = `Bearer ${data.session.access_token}`;
  } else {
    // Public endpoints (e.g. /track/{lr}) have no user session — the
    // anon key alone gets past Supabase's gateway; the function itself
    // decides whether auth is required.
    cfg.headers.Authorization = `Bearer ${SUPABASE_ANON_KEY}`;
  }
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    if (
      err.response?.status === 401 &&
      !window.location.pathname.startsWith("/login") &&
      !window.location.pathname.startsWith("/track") &&
      window.location.pathname !== "/"
    ) {
      await supabase.auth.signOut();
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;
